import { render } from "./a-timeblock.vue?vue&type=template&id=4d980d7a&scoped=true"
import script from "./a-timeblock.vue?vue&type=script&lang=js"
export * from "./a-timeblock.vue?vue&type=script&lang=js"

import "./a-timeblock.vue?vue&type=style&index=0&id=4d980d7a&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d980d7a"]])

export default __exports__